class BottomFixedBar extends HTMLElement {
  constructor() {
    super();
    // read value from localStorage
    this._isHidden = localStorage.getItem('bottom-fixed-bar-closed') === 'true';
    if (this._isHidden) {
      this.classList.add('hide');
    } else {
        this.classList.remove('hide');
    }

    this.querySelector('.bottom-fixed-bar__close').addEventListener('click', this.close);
  }

  close() {
    this.closest('bottom-fixed-bar').classList.add('hide');
    localStorage.setItem('bottom-fixed-bar-closed', 'true');
  }
}

customElements.define('bottom-fixed-bar', BottomFixedBar);